import Footer from "./layout/Footer";
import Head from "./jasa/Head";
import Banner from "./jasa/Banner";
import Article from "./jasa/Article";
import Navbar from "./jasa/Navbar";
import Brand from "./jasa/Brand";
import CustomerReview from "./home/CustomerReview";
import { useParams } from "react-router-dom";
import { Mobile } from "./jasa/Mobile";
import { useMediaQuery } from "react-responsive";

const Jasa = () => {
  const params = useParams();
  const data = params.slug;
  const isBigScreen = useMediaQuery({ query: "(min-width: 700px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 600px)" });
  return (
    <div className="overflow-hidden font-jasa">
      {isBigScreen && (
        <div>
          <Navbar />
          <Head data={data} />
        </div>
      )}
      {isTabletOrMobile && <Mobile data={data} />}
      <Banner />
      <Article data={data} />
      <Brand />
      <CustomerReview />
      <Footer />
    </div>
  );
};

export default Jasa;
